'use strict';

angular.module('mediacloudApp')
    .controller('MainController', function ($scope, $state, $rootScope, Principal, CollectionService, AssetService) {
        $scope.isAuthenticated = Principal.isAuthenticated;

        $scope.currentPage = 0;
        $scope.collectionsPerPage = 5;
        $scope.assetsInCarousel = 5;
        $scope.defaultCarouselInterval = 5000; // This is constant

        // $scope.carouselInterval can have 2 different initial values:
        // - $scope.defaultCarouselInterval => The carousel will start in the Play state.
        // - 0 => The carousel will start in the Pause state.
        $scope.carouselInterval = 0;

        AssetService.GetCarouselAssets.query({limit: $scope.assetsInCarousel}, function(assets){
            $scope.carouselAssets = assets;
        });

        var getHomeCollections = function(limit, page){
            CollectionService.GetHomeCollections.get({limit: limit, offset: page * $scope.collectionsPerPage}, function(result){
                $scope.collections = result.collections;
                $scope.totalCollections = result.totalCollections;
            });
        };

        $scope.openContent = function (item, content) {
            console.log(item)
            var params = {
                collectionType: item.collection.type,
                collectionId: item.collection.cid,
                rootCollectionId: item.collection.cid,
                assetId: content.xid,
                path: item.collection.path
            };

            $state.go("playback", params);
        };

        getHomeCollections($scope.collectionsPerPage, $scope.currentPage);

        $scope.loadMoreCollections = function(){
            $scope.currentPage++;
            CollectionService.GetHomeCollections.get({limit: $scope.collectionsPerPage, offset: $scope.currentPage * $scope.collectionsPerPage}, function(result){
                $scope.collections = $scope.collections.concat(result.collections);
                $scope.totalCollections = result.totalCollections;
            });
        };

        $scope.login = function(nextState) {
            $rootScope.nextState = nextState;
            $state.go('login');
        };

        $scope.$on('loggedOut', function(){
            $scope.currentPage = 0;
            getHomeCollections($scope.collectionsPerPage, $scope.currentPage);
        });

        // This is called whenever an asset is made favorite or not favorite
        $scope.toggleFavorite = function(asset){
            var isFavorite = asset.isFavorite;
            AssetService.toggleAssetFavorite(asset, asset.aid, asset.cid)
                .then(function(response){
                    if(response.result){
                        asset.isFavorite = !isFavorite;
                    }
                }).catch(function() {
                    $log.error("An error occurred when trying to make asset favorite");
                });
        };

        $scope.playAsset = function(collectionId, assetId, type){
            $state.go('playback', {collectionType: type, collectionId: collectionId, assetId: assetId});
        };

        $scope.changeCarouselInterval = function(newInterval){
            $scope.carouselInterval = newInterval;
        };

        $scope.styleCarousel = function() {
            var intervalId = setInterval(function(){
                if($('.glyphicon.glyphicon-chevron-left').length && $('.glyphicon.glyphicon-chevron-right').length) {
                    clearInterval(intervalId);

                    $('.glyphicon.glyphicon-chevron-left').addClass('fa');
                    $('.glyphicon.glyphicon-chevron-left').addClass('fa-chevron-left');
                    $('.glyphicon.glyphicon-chevron-right').addClass('fa');
                    $('.glyphicon.glyphicon-chevron-right').addClass('fa fa-chevron-right');
                }
            }, 100)
        }

        $scope.styleCarousel();
    });
